import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import useDesignTokens from '../../../themes/useDesignTokens';

const useFullscreenLoaderStyles = () => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(
    () => ({
      fullscreenContainer: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: tokens.colors.bg.primary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: theme.zIndex.modal + 1,
      },
      loader: {
        color: tokens.colors.border.highlightSolid,
      },
    }),
    [tokens, theme],
  );

  return styles;
};

export default useFullscreenLoaderStyles;
